import { lazy, Suspense } from 'react';
import { isTestDomain } from './isTestDomain';

const OnboardingDashboardTestScenariosInner = lazy(() => import('./test-scenarios-inner'));

const OnboardingDashboardTestScenarios = () => {
  const isTest = isTestDomain();
  return isTest ? (
    <Suspense>
      <OnboardingDashboardTestScenariosInner />
    </Suspense>
  ) : null;
};

export default OnboardingDashboardTestScenarios;
